// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3333c9ce","879":"503af8c4"}[chunkId] + ".chunk.js";
};